export default __webpack_public_path__ + "static/media/elefante_md.4922495f.png";